import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/ui/PageHeader';
import { SectionHeading } from '../components/ui/SectionHeading';
import { StepList } from '../components/StepList';
import { CTABand } from '../components/CTABand';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { CandidatForm } from '../components/CandidatForm';
import { ShieldCheck, Briefcase, MessageSquare, FileText, Users, Target, Info, PenTool, ArrowDown } from 'lucide-react';
const CANDIDAT_STEPS = [{
  title: 'Premier contact',
  description: 'Remplissez le formulaire de candidature en ligne pour nous faire part de votre projet.',
  icon: <MessageSquare className="w-6 h-6" data-id="element-738" data-mp="2u5hrn5tolojy" />
}, {
  title: 'Dossier candidat',
  description: 'Transmission de votre CV, lettre de motivation et bulletins scolaires.',
  icon: <FileText className="w-6 h-6" data-id="element-739" data-mp="3modhtqyk74lo" />
}, {
  title: "Entretien d'admission",
  description: 'Échange avec notre équipe pour évaluer votre motivation et la cohérence de votre projet.',
  icon: <Users className="w-6 h-6" data-id="element-740" data-mp="3kojn8oaioehk" />
}, {
  title: 'Positionnement',
  description: 'Validation de votre profil et de vos prérequis pour la formation visée.',
  icon: <Target className="w-6 h-6" data-id="element-741" data-mp="3ukwivrpmh2ey" />
}, {
  title: 'Information complète',
  description: 'Présentation détaillée du rythme, du programme et des attentes du CFA.',
  icon: <Info className="w-6 h-6" data-id="element-742" data-mp="78lnwcrt1w74" />
}, {
  title: "Contrat d'alternance",
  description: "Signature du contrat avec votre entreprise d'accueil et inscription définitive.",
  icon: <PenTool className="w-6 h-6" data-id="element-743" data-mp="h6jcj1dktv09" />
}];
export function Candidater() {
  return <div className="flex flex-col w-full" data-id="element-744" data-mp="h4f72f014nxv">
      <PageHeader title="Candidater chez Zillenium" subtitle="Rejoignez notre CFA et donnez un coup d'accélérateur à votre carrière grâce à l'alternance." data-id="element-745" data-mp="2nxr6dofreieq" />

      <div className="py-16 md:py-24 bg-muted relative overflow-hidden" data-id="element-746" data-mp="38ma6q6yie8h2">
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-747" data-mp="38o4r9k5vbykm" />
        <div className="container max-w-6xl mx-auto relative z-10" data-id="element-748" data-mp="3hm702lvufvig">
          <div className="text-center mb-20 max-w-3xl mx-auto" data-id="element-749" data-mp="3mljovc69zcno">
            <p className="text-xl md:text-2xl text-primary-dark/80 leading-relaxed font-medium" data-id="element-750" data-mp="3mmurh8nzied7">
              Que vous soyez lycéen, étudiant, en reconversion ou parent
              accompagnant un jeune dans son orientation, notre équipe est là
              pour vous guider à chaque étape de votre admission.
            </p>
            <div className="mt-10" data-id="element-751" data-mp="96nbw1a153a9">
              <Button size="lg" className="group bg-brand-orange hover:bg-[#E67E22] text-white text-lg px-10 py-7 shadow-xl" onClick={() => document.getElementById('candidat-form')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-752" data-mp="95locxbtuobn">
                Remplir le formulaire de candidature
                <ArrowDown className="w-5 h-5 ml-2 group-hover:translate-y-1 transition-transform" data-id="element-753" data-mp="1ymzg2kcih2q2" />
              </Button>
            </div>
          </div>

          <div className="grid lg:grid-cols-5 gap-16 items-start mb-24" data-id="element-754" data-mp="1opuqsbndcr51">
            <div className="lg:col-span-3" data-id="element-755" data-mp="1orp8zi79a55f">
              <SectionHeading title="Le processus d'admission" className="mb-12" data-id="element-756" data-mp="2mdmpxb5zm2f9" />
              <StepList steps={CANDIDAT_STEPS} data-id="element-757" data-mp="2hes6c70749u3" />
            </div>

            <div className="lg:col-span-2 space-y-8 sticky top-8" data-id="element-758" data-mp="2cms242d3eurp">
              <Card className="bg-white border-none shadow-xl hover:-translate-y-2 transition-all duration-300 group" data-id="element-759" data-mp="27ogrvqivyi8y">
                <div className="h-2 w-full bg-brand-orange" data-id="element-760" data-mp="354e5wvkhcr2m" />
                <CardContent className="p-8" data-id="element-761" data-mp="355xncphvh85z">
                  <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-762" data-mp="30cw2m0uzieeh">
                    <Briefcase className="w-8 h-8 text-brand-orange animate-soft-bounce" data-id="element-763" data-mp="2kxh7qtpvm4bw" />
                  </div>
                  <h3 className="font-extrabold font-heading text-2xl text-primary-dark mb-4" data-id="element-764" data-mp="2ax6y1j31vf1h">
                    Aide à la recherche d'entreprise
                  </h3>
                  <p className="text-lg text-muted-foreground leading-relaxed mb-6" data-id="element-765" data-mp="2fy4fftg8k51x">
                    Une fois votre candidature validée, Zillenium Alternance
                    vous accompagne activement dans votre recherche d'employeur
                    (ateliers CV, préparation aux entretiens, mise en relation
                    avec notre réseau de partenaires).
                  </p>
                  <Button variant="outline" className="w-full border-primary/20 text-primary-dark hover:bg-primary/5 font-semibold" onClick={() => document.getElementById('cap-360-section')?.scrollIntoView({
                  behavior: 'smooth'
                })} data-id="element-766" data-mp="2yst2v27y1wtc">
                    En savoir plus sur l'accompagnement CAP 360
                  </Button>
                </CardContent>
              </Card>

              <Card className="bg-primary-dark text-white border-none shadow-xl hover:-translate-y-2 transition-all duration-300 group" data-id="element-767" data-mp="1kp13cbh4jy6c">
                <div className="h-2 w-full bg-primary-accent" data-id="element-768" data-mp="rysiucz491ol" />
                <CardContent className="p-8" data-id="element-769" data-mp="s0dfq98wkwpm">
                  <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-770" data-mp="15yaar17pkv26">
                    <ShieldCheck className="w-8 h-8 text-lavande animate-soft-pulse" data-id="element-771" data-mp="2hd72wjz6w0dr" />
                  </div>
                  <h3 className="font-extrabold font-heading text-2xl mb-4" data-id="element-772" data-mp="2dbvlv2udsnh6">
                    Confidentialité
                  </h3>
                  <p className="text-lg text-lavande leading-relaxed" data-id="element-773" data-mp="19zmx2c5blzh4">
                    Les informations recueillies via notre formulaire sont
                    strictement confidentielles et traitées dans le respect du
                    RGPD, uniquement dans le cadre de votre candidature.
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>

      {/* CAP 360 Section */}
      <section id="cap-360-section" className="py-24 bg-white relative overflow-hidden scroll-mt-24" data-id="element-774" data-mp="w9b1g39j1il8">
        <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-brand-orange rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-775" data-mp="10amsmd81ubvj" />
        <div className="container max-w-6xl mx-auto relative z-10" data-id="element-776" data-mp="152wftlhs4xu4">
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-777" data-mp="8insrfrseoxm">
            <div data-id="element-778" data-mp="cl2a1vft5gms">
              <SectionHeading title="CAP 360" subtitle="Un accompagnement vers l'alternance, avant l'entrée en formation" className="mb-8" data-id="element-779" data-mp="ckipe6yrwe52" />
              <p className="text-lg text-muted-foreground leading-relaxed mb-8" data-id="element-780" data-mp="3rh7g5yrglq">
                CAP 360 est un dispositif d'accompagnement mis en place par
                Zillenium Alternance pour aider les futurs apprenants à se
                préparer concrètement à la recherche d'une alternance, avant le
                démarrage des cours. À travers des bootcamps, des ateliers TRE,
                des temps de remise en confiance et un accompagnement
                personnalisé, nous aidons les candidats à lever les freins,
                clarifier leur projet et adopter une posture professionnelle
                adaptée aux attentes des recruteurs.
              </p>

              <div className="bg-muted p-8 rounded-3xl mb-8" data-id="element-781" data-mp="2zid3bo0wgbdz">
                <h4 className="font-bold text-primary-dark mb-4" data-id="element-782" data-mp="2zjo4dg2yn51e">
                  Les futurs apprenants bénéficient notamment de :
                </h4>
                <ul className="space-y-3" data-id="element-783" data-mp="mb3pmqxdsajr">
                  <li className="flex items-start gap-3" data-id="element-784" data-mp="m87qx0dplhu9">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2 shrink-0" data-id="element-785" data-mp="r7u459tjey32"></div>
                    <span className="text-muted-foreground" data-id="element-786" data-mp="d8aycno77ytx">
                      Ateliers de refonte et d'optimisation des CV
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-787" data-mp="3j12cwq8hw0j">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2 shrink-0" data-id="element-788" data-mp="3hgajevb0r6d"></div>
                    <span className="text-muted-foreground" data-id="element-789" data-mp="8ccdha22wyy9">
                      Préparation aux entretiens et simulations en conditions
                      réelles
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-790" data-mp="3unhrg41yaezx">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2 shrink-0" data-id="element-791" data-mp="3gre0cjmdimro"></div>
                    <span className="text-muted-foreground" data-id="element-792" data-mp="3lnumj8a0ir24">
                      Travail sur la confiance en soi, l'expression orale et la
                      posture professionnelle
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-793" data-mp="2x6nhdvqsa89a">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2 shrink-0" data-id="element-794" data-mp="3c2bi3aww8d8f"></div>
                    <span className="text-muted-foreground" data-id="element-795" data-mp="371fcmsww8j0w">
                      Accompagnement pour dépasser les freins psychologiques
                      liés à la recherche d'emploi
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-796" data-mp="3g12grmh0c2xn">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2 shrink-0" data-id="element-797" data-mp="3ur009p3zs4gi"></div>
                    <span className="text-muted-foreground" data-id="element-798" data-mp="3ptzsn9rhutna">
                      Interventions de professionnels et de partenaires du
                      terrain
                    </span>
                  </li>
                </ul>
              </div>

              <p className="text-lg text-primary-dark font-bold leading-relaxed mb-8" data-id="element-799" data-mp="3jx8owk8rw5r">
                CAP 360 repose sur un travail commun entre l'étudiant et
                l'équipe Zillenium Alternance. L'objectif n'est pas de faire à
                la place, mais de donner les outils, la méthode et le cadre pour
                permettre à chacun de s'engager efficacement dans sa recherche
                d'alternance.
              </p>
              <Button size="lg" className="group bg-brand-orange hover:bg-[#E67E22] text-white text-lg px-8 py-6 shadow-xl" onClick={() => document.getElementById('candidat-form')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-800" data-mp="384l7czug52nh">
                Remplir le formulaire de candidature
                <ArrowDown className="w-5 h-5 ml-2 group-hover:translate-y-1 transition-transform" data-id="element-801" data-mp="1mt3022x8f5uc" />
              </Button>
            </div>

            <div className="grid gap-6" data-id="element-802" data-mp="3ue1oadrf8zyg">
              <Card className="border-none shadow-xl hover:-translate-y-2 transition-transform duration-300 group bg-white" data-id="element-803" data-mp="3uf31anrzzwit">
                <div className="h-2 w-full bg-primary" data-id="element-804" data-mp="2ain0bnkmoho" />
                <CardContent className="p-8 flex items-center gap-6" data-id="element-805" data-mp="78tzyv95xf44">
                  <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-300" data-id="element-806" data-mp="c026njj3ymdl">
                    <Target className="w-8 h-8 text-primary animate-soft-bounce" data-id="element-807" data-mp="gynbjw9b1u8d" />
                  </div>
                  <div data-id="element-808" data-mp="lwf14jmh949e">
                    <h3 className="font-extrabold font-heading text-xl text-primary-dark mb-1" data-id="element-809" data-mp="pztra344r10k">
                      CLARIFIER
                    </h3>
                    <p className="text-muted-foreground" data-id="element-810" data-mp="uxmz10l3032y">
                      Définir un projet clair et réaliste
                    </p>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-none shadow-xl hover:-translate-y-2 transition-transform duration-300 group bg-white" data-id="element-811" data-mp="2wqjh37des5wk">
                <div className="h-2 w-full bg-brand-orange" data-id="element-812" data-mp="3xnlhsvhr7x7" />
                <CardContent className="p-8 flex items-center gap-6" data-id="element-813" data-mp="3v3oqbjov55ae">
                  <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-300" data-id="element-814" data-mp="cwr6j2e7xxec">
                    <Briefcase className="w-8 h-8 text-brand-orange animate-soft-pulse" data-id="element-815" data-mp="muotzno97q5w" />
                  </div>
                  <div data-id="element-816" data-mp="hvtzhogxcd5y">
                    <h3 className="font-extrabold font-heading text-xl text-primary-dark mb-1" data-id="element-817" data-mp="huiyfwev5jij">
                      STRUCTURER
                    </h3>
                    <p className="text-muted-foreground" data-id="element-818" data-mp="votezqgpi7di">
                      Méthode, outils et cadre pour avancer
                    </p>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-none shadow-xl hover:-translate-y-2 transition-transform duration-300 group bg-white" data-id="element-819" data-mp="10mbqnom3z0p7">
                <div className="h-2 w-full bg-primary-dark" data-id="element-820" data-mp="1k7lmvfwelffa" />
                <CardContent className="p-8 flex items-center gap-6" data-id="element-821" data-mp="1p6yba52xaujz">
                  <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-300" data-id="element-822" data-mp="1p66q7o6ycf7y">
                    <Users className="w-8 h-8 text-primary-dark animate-soft-float" data-id="element-823" data-mp="1f7qzvnfr19zi" />
                  </div>
                  <div data-id="element-824" data-mp="11glvk81frtiu">
                    <h3 className="font-extrabold font-heading text-xl text-primary-dark mb-1" data-id="element-825" data-mp="11g2l1ce487eu">
                      ACTIVER
                    </h3>
                    <p className="text-muted-foreground" data-id="element-826" data-mp="rjzb3kd0v4hc">
                      Passer à l'action face aux recruteurs
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      <div id="candidat-form" className="py-24 bg-muted scroll-mt-24" data-id="element-827" data-mp="mk3ggbq7speg">
        <div className="container max-w-4xl mx-auto" data-id="element-828" data-mp="mm7kqus0zqf9">
          <div className="bg-white border-none rounded-3xl p-8 md:p-16 text-center shadow-2xl relative overflow-hidden" data-id="element-829" data-mp="fh6g8oduzc18">
            <div className="absolute top-0 right-0 w-64 h-64 bg-brand-orange rounded-full blur-[80px] opacity-10 pointer-events-none" data-id="element-830" data-mp="aj4zwb7thqtg" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-primary rounded-full blur-[80px] opacity-10 pointer-events-none" data-id="element-831" data-mp="5oqy9r2kangc" />

            <div className="relative z-10" data-id="element-832" data-mp="3sw33cs3tj1sd">
              <h2 className="text-4xl font-extrabold font-heading text-primary-dark mb-6" data-id="element-833" data-mp="3sx4fz10hfwc7">
                Prêt à vous lancer ?
              </h2>
              <p className="text-xl text-muted-foreground mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-834" data-mp="3ix3sr3zhsw2q">
                "Bienvenue ! Ce formulaire rapide nous permet de mieux vous
                connaître et de comprendre votre projet professionnel..."
              </p>
              <div className="mt-8" data-id="element-835" data-mp="1h3wcnsc22afs">
                <CandidatForm data-id="element-836" data-mp="1c6xkhfbycdk8" />
              </div>
              <div className="mt-12 pt-8 border-t border-slate-100" data-id="element-837" data-mp="1c52xzwl18de1">
                <Link to="/entreprises" className="text-base font-medium text-primary hover:text-brand-orange transition-colors underline underline-offset-4" data-id="element-838" data-mp="1kneql4k3b4tz">
                  Vous êtes une entreprise ? Recruter un alternant
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}